import {Col, Row} from 'react-bootstrap';

const MessageSubject = ({message}) => (
  <Row className="message-subject">
    <Col lg={12}>
      Subject: {message.attributes.subject || ''}
    </Col>
  </Row>
);

export default MessageSubject;
